import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import BarChartIcon from '@mui/icons-material/BarChart';
import LayersIcon from '@mui/icons-material/Layers';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/Notifications';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LogoutOutlined from '@mui/icons-material/LogoutOutlined';
import ForumIcon from '@mui/icons-material/Forum';
import PublicIcon from '@mui/icons-material/Public';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import PolicyIcon from '@mui/icons-material/Policy';
import TuneIcon from '@mui/icons-material/Tune';
import ArticleIcon from '@mui/icons-material/Article';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import AddIcon from '@mui/icons-material/Add';
import DataObjectIcon from '@mui/icons-material/DataObject';
import InfoIcon from '@mui/icons-material/Info';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import EditNoteIcon from '@mui/icons-material/EditNote';
import PasswordIcon from '@mui/icons-material/Password';
import GoogleIcon from '@mui/icons-material/Google';
import PersonIcon from '@mui/icons-material/Person';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CopyIdIcon from './CopyIdIcon';
import McpIcon from './McpIcon';
import DohIcon from './DohIcon';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import GroupIcon from '@mui/icons-material/Group';
import GroupsIcon from '@mui/icons-material/Groups';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import ModelTrainingIcon from '@mui/icons-material/ModelTraining';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckIcon from '@mui/icons-material/Check';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import BusinessIcon from '@mui/icons-material/Business';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import DownloadIcon from '@mui/icons-material/Download';
import LinkIcon from '@mui/icons-material/Link';
import AssignmentIcon from '@mui/icons-material/Assignment';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import LockClockIcon from '@mui/icons-material/LockClock';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import CallMadeIcon from '@mui/icons-material/CallMade';
import ImageIcon from '@mui/icons-material/Image';
import DeviceHub from '@mui/icons-material/DeviceHub';
import SettingsIcon from '@mui/icons-material/Settings';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import SettingsInputCompositeIcon from '@mui/icons-material/SettingsInputComposite';
import MailLockIcon from '@mui/icons-material/MailLock';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SortByAlphaIcon from '@mui/icons-material/SortByAlpha';
import SortIcon from '@mui/icons-material/Sort';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import AssistantIcon from '@mui/icons-material/Assistant';
import BadgeIcon from '@mui/icons-material/Badge';
import IosShareIcon from '@mui/icons-material/IosShare';
import RuleIcon from '@mui/icons-material/Rule';
import DownloadingIcon from '@mui/icons-material/Downloading';
import SummarizeIcon from '@mui/icons-material/Summarize';
import HelpIcon from '@mui/icons-material/Help';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import CloudIcon from '@mui/icons-material/Cloud';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import SecurityIcon from '@mui/icons-material/Security';
import VisibilityIcon from '@mui/icons-material/Visibility';
import RuleFolderIcon from '@mui/icons-material/RuleFolder';
import FlagIcon from '@mui/icons-material/Flag';
import VerticalSplitIcon from '@mui/icons-material/VerticalSplit';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import RotatedMediationIcon from './RotatedMediationIcon';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import BlockIcon from '@mui/icons-material/Block';
import TimelineIcon from '@mui/icons-material/Timeline';
import ListIcon from '@mui/icons-material/List';
import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import RemoveIcon from '@mui/icons-material/Remove';
import HttpsIcon from '@mui/icons-material/Https';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import RegexIcon from './RegexIcon';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import BoltIcon from '@mui/icons-material/Bolt';

export type IconType =
  | 'people'
  | 'supervisor'
  | 'person'
  | 'bar-chart'
  | 'layers'
  | 'chevron-left'
  | 'chevron-right'
  | 'expand'
  | 'menu'
  | 'notifs'
  | 'lock'
  | 'log-out'
  | 'chat'
  | 'globe'
  | 'enterprise'
  | 'policy'
  | 'tune'
  | 'article'
  | 'close'
  | 'search'
  | 'refresh'
  | 'plus-circle'
  | 'plus'
  | 'json'
  | 'info-circle'
  | 'arrow-right'
  | 'arrow-left'
  | 'text-file'
  | 'edit'
  | 'google'
  | 'password'
  | 'delete'
  | 'copy'
  | 'copy-id'
  | 'save'
  | 'cancel'
  | 'group'
  | 'groups'
  | 'group-work'
  | 'lock-person'
  | 'model-training'
  | 'check-circle'
  | 'check'
  | 'more-horiz'
  | 'organization'
  | 'network-error'
  | 'deny'
  | 'download'
  | 'link'
  | 'assignment'
  | 'time-lapse'
  | 'lock-clock'
  | 'doc-search'
  | 'question-mark'
  | 'arrow-double-up'
  | 'arrow-double-down'
  | 'upload'
  | 'image'
  | 'vector'
  | 'device-hub'
  | 'settings'
  | 'assume-role'
  | 'plug'
  | 'assessment'
  | 'magic-link'
  | 'alpha-sort'
  | 'sort'
  | 'unlock'
  | 'assistant'
  | 'certificate'
  | 'telemetry'
  | 'test'
  | 'export'
  | 'report'
  | 'help'
  | 'manage-accounts'
  | 'cloud'
  | 'models'
  | 'security'
  | 'monitor'
  | 'classifier'
  | 'risk'
  | 'catalog'
  | 'mcp-server'
  | 'logs'
  | 'documentation'
  | 'light-mode'
  | 'dark-mode'
  | 'thumbs-up'
  | 'thumbs-down'
  | 'sub-arrow-right'
  | 'sdk'
  | 'proxy'
  | 'drawer-open'
  | 'open-in-new'
  | 'block'
  | 'timeline'
  | 'list'
  | 'emergency'
  | 'remove'
  | 'https'
  | 'doh'
  | 'tips-and-updates'
  | 'regex'
  | 'first-page'
  | 'live';

type IconElementType = OverridableComponent<SvgIconTypeMap<object, 'svg'>> & {
  muiName: string;
};

export const IconMap: Map<IconType, IconElementType> = new Map();
IconMap.set('people', PeopleIcon);
IconMap.set('supervisor', SupervisedUserCircleIcon);
IconMap.set('person', PersonIcon);
IconMap.set('bar-chart', BarChartIcon);
IconMap.set('layers', LayersIcon);
IconMap.set('chevron-left', ChevronLeftIcon);
IconMap.set('chevron-right', ChevronRightIcon);
IconMap.set('menu', MenuIcon);
IconMap.set('notifs', NotificationsIcon);
IconMap.set('lock', LockOutlinedIcon);
IconMap.set('log-out', LogoutOutlined);
IconMap.set('chat', ForumIcon);
IconMap.set('globe', PublicIcon);
IconMap.set('enterprise', CorporateFareIcon);
IconMap.set('policy', PolicyIcon);
IconMap.set('tune', TuneIcon);
IconMap.set('article', ArticleIcon);
IconMap.set('close', CloseIcon);
IconMap.set('search', SearchIcon);
IconMap.set('refresh', RefreshIcon);
IconMap.set('plus-circle', AddCircleIcon);
IconMap.set('plus', AddIcon);
IconMap.set('json', DataObjectIcon);
IconMap.set('info-circle', InfoIcon);
IconMap.set('arrow-right', ArrowForwardIcon);
IconMap.set('arrow-left', ArrowBackIcon);
IconMap.set('text-file', TextSnippetIcon);
IconMap.set('edit', EditNoteIcon);
IconMap.set('google', GoogleIcon);
IconMap.set('password', PasswordIcon);
IconMap.set('delete', RemoveCircleIcon);
IconMap.set('copy', ContentCopyIcon);
IconMap.set('copy-id', CopyIdIcon);
IconMap.set('save', SaveIcon);
IconMap.set('cancel', CancelIcon);
IconMap.set('group', GroupIcon);
IconMap.set('groups', GroupsIcon);
IconMap.set('group-work', GroupWorkIcon);
IconMap.set('lock-person', LockPersonIcon);
IconMap.set('model-training', ModelTrainingIcon);
IconMap.set('check-circle', CheckCircleIcon);
IconMap.set('check', CheckIcon);
IconMap.set('more-horiz', MoreHorizIcon);
IconMap.set('organization', BusinessIcon);
IconMap.set('network-error', WarningAmberIcon);
IconMap.set('deny', DoNotDisturbIcon);
IconMap.set('download', DownloadIcon);
IconMap.set('link', LinkIcon);
IconMap.set('assignment', AssignmentIcon);
IconMap.set('time-lapse', TimelapseIcon);
IconMap.set('lock-clock', LockClockIcon);
IconMap.set('doc-search', DocumentScannerIcon);
IconMap.set('question-mark', QuestionMarkIcon);
IconMap.set('arrow-double-up', KeyboardDoubleArrowUpIcon);
IconMap.set('arrow-double-down', KeyboardDoubleArrowDownIcon);
IconMap.set('expand', ExpandMoreIcon);
IconMap.set('upload', FileUploadIcon);
IconMap.set('image', ImageIcon);
IconMap.set('vector', CallMadeIcon);
IconMap.set('device-hub', DeviceHub);
IconMap.set('settings', SettingsIcon);
IconMap.set('assume-role', AdminPanelSettingsIcon);
IconMap.set('plug', SettingsInputCompositeIcon);
IconMap.set('assessment', AssessmentIcon);
IconMap.set('magic-link', MailLockIcon);
IconMap.set('alpha-sort', SortByAlphaIcon);
IconMap.set('sort', SortIcon);
IconMap.set('unlock', LockOpenIcon);
IconMap.set('assistant', AssistantIcon);
IconMap.set('certificate', BadgeIcon);
IconMap.set('telemetry', IosShareIcon);
IconMap.set('test', RuleIcon);
IconMap.set('export', DownloadingIcon);
IconMap.set('report', SummarizeIcon);
IconMap.set('help', HelpIcon);
IconMap.set('manage-accounts', ManageAccountsIcon);
IconMap.set('cloud', CloudIcon);
IconMap.set('models', AutoAwesomeIcon);
IconMap.set('security', SecurityIcon);
IconMap.set('monitor', VisibilityIcon);
IconMap.set('classifier', RuleFolderIcon);
IconMap.set('risk', FlagIcon);
IconMap.set('catalog', VerticalSplitIcon);
IconMap.set('mcp-server', McpIcon);
IconMap.set('logs', ListAltIcon);
IconMap.set('documentation', ImportContactsIcon);
IconMap.set('light-mode', LightModeIcon);
IconMap.set('dark-mode', DarkModeIcon);
IconMap.set('thumbs-up', ThumbUpIcon);
IconMap.set('thumbs-down', ThumbDownIcon);
IconMap.set('sub-arrow-right', SubdirectoryArrowRightIcon);
IconMap.set('sdk', IntegrationInstructionsIcon);
IconMap.set('proxy', RotatedMediationIcon);
IconMap.set('drawer-open', MenuOpenIcon);
IconMap.set('open-in-new', OpenInNewIcon);
IconMap.set('block', BlockIcon);
IconMap.set('timeline', TimelineIcon);
IconMap.set('list', ListIcon);
IconMap.set('emergency', CrisisAlertIcon);
IconMap.set('remove', RemoveIcon);
IconMap.set('https', HttpsIcon);
IconMap.set('doh', DohIcon);
IconMap.set('tips-and-updates', TipsAndUpdatesIcon);
IconMap.set('regex', RegexIcon);
IconMap.set('first-page', FirstPageIcon);
IconMap.set('live', BoltIcon);

export type IconColor =
  | 'white'
  | 'black'
  | 'grey'
  | 'active'
  | 'success'
  | 'info'
  | 'error'
  | 'link';

type IconFontSizeLabel = 'small' | 'medium' | 'large';

export const getSizeProp = (
  size: string
): { fontSize: IconFontSizeLabel } | { sx: { fontSize: number } } => {
  if (['small', 'medium', 'large'].includes(size)) {
    return { fontSize: size as IconFontSizeLabel };
  }

  switch (size) {
    case 'x-small':
      return { sx: { fontSize: 14 } };
    case 'x-large':
      return { sx: { fontSize: 50 } };
  }

  return { fontSize: 'medium' };
};
